import {useEffect} from 'react';
import {IS_CBT_OR_PROD} from '../../common/constant';
import {getKakaoAppKey} from '../../common/function';
import {getKakaoSdk} from '../function';

export default function useKakaoSdk() {
  useEffect(() => {
    // 1.39.14
    const kakaoJsName = `${IS_CBT_OR_PROD ? '' : 'sandbox-'}kakao.min.js`;
    // @ts-ignore
    import(`../../../public/static/js/${kakaoJsName}`).then(() => {
      const windowKakao = getKakaoSdk();
      !windowKakao?.isInitialized() && windowKakao.init(getKakaoAppKey());
    });
  }, []);
}
